import Component from '@bythepixel/component-loader';

export default class ContentModal extends Component {
  static selector = '[comp-content-modal]'

  constructor(...args) {
    super(...args);

    this.subscribeEvent = this.$container.getAttribute('menu-event');
    this.events();

    this.$state = {
      open: false,
    };
    this.setHiddenClasses = this.setHiddenClasses.bind(this);
  }

  events() {
    this.$subscribe(this.subscribeEvent, () => this.toggleMenu());
  }

  toggleMenu() {
    return this.$state.open ? this.hideMenu() : this.showMenu();
  }

  showMenu() {
    this.$container.classList.add('opacity-0', 'transform');
    this.$container.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      this.$container.classList.remove('opacity-0', 'transform');
      this.$state.open = true;
    }, 20);
  }

  hideMenu() {
    this.$container.classList.add('opacity-0', 'transform');
    document.body.classList.remove('overflow-hidden');
    this.$container.addEventListener('transitionend', this.setHiddenClasses);
  }

  setHiddenClasses() {
    this.$container.classList.add('hidden');
    this.$state.open = false;
    this.$container.removeEventListener('transitionend', this.setHiddenClasses);
  }
}
